import React, { useState } from 'react';
import ProfessoresList from '../components/ProfessoresList';
import ProfessoresForm from '../components/ProfessoresForm';
import ProfessoresDetails from './ProfessoresDetails';
import ImportContactsModal from '../components/ImportContactsModal';
import './Professores.css'; // Importando o CSS

function Professores() {
  const [selectedProfessor, setSelectedProfessor] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="professores-container">
      <h1>Professores</h1>

      {/* Campo de busca - Exibido apenas quando não estiver criando ou importando */}
      {!isCreating && !isImporting && (
        <input
          type="text"
          placeholder="Buscar por nome..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      )}

      {isCreating ? (
        <ProfessoresForm onCancel={() => setIsCreating(false)} />
      ) : (
        <>
          <button onClick={() => setIsCreating(true)}>Adicionar</button>
          <button onClick={() => setIsImporting(true)}>Importar</button>
          <ProfessoresList
            onSelect={(professor) => setSelectedProfessor(professor)}
            searchTerm={searchTerm}
          />
        </>
      )}

      {selectedProfessor && (
        <ProfessoresDetails
          professor={selectedProfessor}
          onClose={() => setSelectedProfessor(null)}
        />
      )}

      {isImporting && (
        <ImportContactsModal onClose={() => setIsImporting(false)} />
      )}
    </div>
  );
}

export default Professores;
